import setContextualFormatBarTarget from '../actions/setContextualFormatBarTarget';
import updateFirstClassState from '../actions/updateFirstClassState';
import updateRibbonState from '../actions/updateRibbonState';
import { getElementBasedFormatState, getPendableFormatState } from 'roosterjs-editor-api';
import { orchestrator } from 'satcheljs';

// The interval to pull ribbon state
const RIBBON_STATE_POLL_INTERVAL: number = 500;

let ribbonStateJobId: number;

orchestrator(updateRibbonState, actionMessage => {
    const { plugin, viewState, updateContextualFormatBar, delay } = actionMessage;

    if (ribbonStateJobId) {
        window.clearTimeout(ribbonStateJobId);
    }

    let func = () => {
        ribbonStateJobId = null;
        let editor = plugin.getEditor();
        let pendableState = editor && getPendableFormatState(editor.getDocument());
        let elementBasedState = editor && getElementBasedFormatState(editor);
        if (pendableState && elementBasedState) {
            elementBasedState.canAddImageAltText = !!plugin.getImageSelectedByPlugin();
            updateFirstClassState(
                viewState.formatViewState,
                pendableState,
                elementBasedState,
                editor.canUndo(),
                editor.canRedo()
            );
        }

        // Need to check editor.isDisposed() since we have async operation above and editor might be disposed during this time
        if (updateContextualFormatBar && editor && !editor.isDisposed()) {
            let range = editor.hasFocus() ? editor.getSelectionRange() : null;
            let hasTextSelection = range ? !range.collapsed : false;
            if (hasTextSelection && !viewState.targetPoint) {
                let rect = editor.getCursorRect();
                if (rect) {
                    // Rect.left and Rect.right are the same, so no need to consider RTL
                    setContextualFormatBarTarget(viewState, { x: rect.left, y: rect.top });
                }
            } else if (!hasTextSelection && viewState.targetPoint) {
                setContextualFormatBarTarget(viewState, null /*targetPoint*/);
            }
        }
    };

    if (delay) {
        ribbonStateJobId = window.setTimeout(func, RIBBON_STATE_POLL_INTERVAL);
    } else {
        func();
    }
});
